module.exports = __webpack_public_path__ + "9cea817f10b6972642c3b706374adee3.svg";